export function isCommentResolved(comment) {
  return !!comment?.resolvedDate;
}

export function isCommentUnresolved(comment) {
  return !comment?.resolvedDate;
}
